import React from "react";
import InstallationAllTabs from "../installation/InstallationAllTabs";

export default function InstallationTable({
  setOpenModalToCreateJobBatches,
  openModalToCreateJobBatches,
  campaignData
}) {
  return (
    <div>
      <InstallationAllTabs
        openModalToCreateJobBatches={openModalToCreateJobBatches}
        setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
        campaignData={campaignData}
      />
    </div>
  );
}
